import React from 'react'
import { noWifiImg } from '../../images/TeleBindingImages/TeleBindingImages'

const TechnicalErrorScreen = () => {
  return (
    <div className='technical-error-screen'>
    <div className='technical-error-content'>
        <div className='no-wifi-img'>
          <img src={noWifiImg} alt='No Wifi' />
        </div>
        <div className='technical-error-content-text'>
          <h2>Sorry to keep you waiting!</h2>

          <p>
            Unable to submit your details due to<br /> a technical issue. Please try again<br />after some time
          </p>

          <span>
            For further assistance, please <br />connect with our seller.
          </span>
        </div>
    </div>
    <div>
    </div>
  </div>
  )
}

export default TechnicalErrorScreen